"use client"

import { useState } from "react"
import { cn } from "@/lib/utils"
import { AutoTradingStocksTab } from "@/components/trading/AutoTradingStocksTab"
import { StrategyParamsTab } from "@/components/trading/StrategyParamsTab"
import { TradeHistoryTab } from "@/components/trading/TradeHistoryTab"

const PAGE_TABS = [
  { key: "stocks",   label: "자동매매 종목" },
  { key: "strategy", label: "조건식 매매 설정" },
  { key: "trades",   label: "매매내역" },
] as const

type PageTab = (typeof PAGE_TABS)[number]["key"]

export default function TradingPage() {
  const [tab, setTab] = useState<PageTab>("stocks")

  return (
    <div className="flex flex-col gap-4">
      {/* 상단 탭 */}
      <div className="flex border-b border-zinc-800">
        {PAGE_TABS.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={cn(
              "-mb-px min-h-[40px] border-b-2 px-6 text-sm font-medium transition-colors",
              tab === key
                ? "border-emerald-400 text-emerald-400"
                : "border-transparent text-zinc-400 hover:text-zinc-100"
            )}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === "stocks" ? (
        <AutoTradingStocksTab />
      ) : tab === "strategy" ? (
        <StrategyParamsTab />
      ) : (
        <TradeHistoryTab />
      )}
    </div>
  )
}
